// extracted by mini-css-extract-plugin
export default {"cCointainer":"Cart_cCointainer__6nKUT","checkout":"Cart_checkout__AiILd","emptyCartVector":"Cart_emptyCartVector__nFf4d","pcDesc":"Cart_pcDesc__ougAN"};